import { UI_SET_LOADER, UI_SET_LOADER_TEXT, SET_UI_PROPERTY } from 'store/actions/ui';
import { setValueObjectByField } from 'helpers/object';

export default {
  [SET_UI_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },

  [UI_SET_LOADER]: (state, loading) => {
    state.loader = loading;
  },

  [UI_SET_LOADER_TEXT]: (state, text) => {
    state.loaderText = text;
  }
};
